import { Branding, DisabledPrompt, Link, useParams } from "@bcm-dev/bcms-vite";
import MainContentContainer, { MainContentHeader, MainContentSection } from "components/shared/containers/MainContentContainer";
import AlertsToggleView from "components/shared/views/BaseToggleView/components/AlertsToggleView";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";
/**
 * @function LocationAlertsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for LocationAlertsPage
 */

export default function LocationAlertsPage(props) {
  const location = props.location ?? "Home";
  const cardID = useParams().cardID ?? "0";

  return (
    <MainContentContainer className="location-alerts-page" header={<MainContentHeader text="Location Alerts" />}>
      <AlertsToggleView 
        mainText="My Regions" 
        subText="All in-store transactions will generate an alert if merchant location is outside selected regions." 
        className="hide-chevron-icon"
        toggleBlock ={
          <MainContentSection 
            text="Add Region" 
            icon={
              <Link to={ `/home/region/${ cardID }` }>
                <SVGAsset id="CirclePlusIcon" className="clickable" />
              </Link>}
            >
        <DisabledPrompt>      
          <div className="region-added-row flex-container flex-horizontal align-center-container clickable">
            
              <div className="set-width">
                <SVGAsset id="PencilIcon" className="left-inline-icon" />
              </div>
            <div className="flex-width">
              {location}
            </div>
              <div className="set-width">
                <SVGAsset id="CircleMinusIcon" />
              </div>
          </div>
       </DisabledPrompt>
      </MainContentSection>
        }
      />  
      <Branding id="Alerts_Locations_International_chw23" exp={ val => val === "true" }>
        <AlertsToggleView 
            mainText="International"
            subText="All international in-store transactions generate an alert."
            className="hide-chevron-icon"
          />
      </Branding>
        
    </MainContentContainer>
  );
}